/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_TitleInputs */

const en_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Import`)
};

const fr_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des medias`)
};

const de_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport`)
};

const it_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione multimediale`)
};

const ru_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов`)
};

const es_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de medios`)
};

const zh_cn2_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体导入`)
};

const ja_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアインポート`)
};

const hi_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया आयात`)
};

const pt_pt2_media_import_title = /** @type {(inputs: Media_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de mídia`)
};

/**
* | output |
* | --- |
* | "Media Import" |
*
* @param {Media_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_title = /** @type {((inputs?: Media_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_title(inputs)
	if (locale === "de") return de_media_import_title(inputs)
	if (locale === "it") return it_media_import_title(inputs)
	if (locale === "ru") return ru_media_import_title(inputs)
	if (locale === "es") return es_media_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_title(inputs)
	if (locale === "ja") return ja_media_import_title(inputs)
	if (locale === "hi") return hi_media_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_title(inputs)
	return en_media_import_title(inputs)
});